<template>
    <tabs type="primary" centered :value="classroom.converted ? 'Kodesh' : 'General'">
        <tab-pane v-if="classroom.converted === false" label="General">
            <div class="row">
                <div class="col-lg-12">
                    <hotline-card title="Recorded lessons" subtitle="4"
                                  :resource-url="baseAPIURL + 'classroom/' + classroom.id + '/message/lessons/'"
                    ></hotline-card>
                </div>
                <div class=" col-lg-12">
                    <hotline-card title="Other Messages" subtitle="6"
                                  :resource-url="baseAPIURL + 'classroom/' + classroom.id + '/message/other/'"
                    ></hotline-card>
                </div>

                <div class="col-lg-12">
                    <card>
                        <h4>Voicemail box</h4>
                        <div class="description">
                            <p>
                                The PIN is {{ voicemail.password }}
                            </p>
                        </div>
                        <div class="row table-full-width">
                            <div class="col-sm-12">
                                <div v-if="loading.voicemail" class="loading">
                                    <div class="text-center" style="font-size: 5rem;">
                                        <font-awesome-icon :icon="['fal','spinner-third']"
                                                           spin></font-awesome-icon>
                                    </div>
                                </div>
                                <el-table
                                    v-if="!loading.voicemail"
                                    :data="voicemail.messages"
                                    max-height="250"
                                    size="small">
                                    <el-table-column prop="number" label="#" width="50">
                                    </el-table-column>
                                    <el-table-column min-width="180" label="Player">
                                        <template slot-scope="scope">
                                            <vue-plyr
                                                :options="{'controls': [ 'play','progress','current-time','download']}">
                                                <audio preload="none">
                                                    <source :src="scope.row.file" type="audio/wav"/>
                                                </audio>
                                            </vue-plyr>
                                        </template>

                                    </el-table-column>
                                    <el-table-column
                                        header-align="right"
                                        align="right"
                                        width="100"
                                        label="Actions">
                                        <div slot-scope="{ row,$index  }"
                                             class="text-right table-actions">
                                            <base-button
                                                v-on:click="removeVoicemailMessage(row.number)"
                                                type="danger"
                                                icon
                                                :loading="voicemailmessages[row.number]"
                                                size="sm"
                                                class="btn-link">
                                                <font-awesome-icon
                                                    :icon="['fal','trash']"></font-awesome-icon>
                                            </base-button>

                                        </div>
                                    </el-table-column>
                                    <div slot="empty">
                                        <span>You have no messages in this classroom</span>
                                    </div>
                                </el-table>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </tab-pane>
        <tab-pane v-if="classroom.converted" label="Kodesh">
            <subject :classroom="classroom" subject="kodesh"/>
        </tab-pane>
        <tab-pane v-if="classroom.converted" label="Chol">
            <subject :classroom="classroom" subject="chol"/>
        </tab-pane>
        <tab-pane v-if="classroom.converted" label="Other">
            <subject :classroom="classroom" subject="other"/>
        </tab-pane>
    </tabs>
</template>
<script>
    import HotlineCard from "./HotlineCard"
    import {TabPane, Tabs,} from 'src/components';
    import axios from "axios";
    import swal from "sweetalert2";
    import ChangeSubjectGreetingCard from "./ChangeSubjectGreetingCard";
    import Subject from "./Subject";

    export default {
        name: 'classroom-subjects',
        components: {
            Subject,
            ChangeSubjectGreetingCard,
            HotlineCard, TabPane,
            Tabs,
        },
        props: {
            classroom: {},
        },
        data() {
            return {
                loading: {voicemail: true},
                voicemailmessages: [],
                voicemail: {},

            };
        },
        mounted() {
            this.loadVoicemail();
        },
        methods: {
            loadVoicemail() {
                this.loading.voicemail = true;
                axios({
                    url: this.baseAPIURL + 'classroom/' + this.classroom.id + '/voicemail', method: 'GET', headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                }).then(resp => {
                    this.voicemail = resp.data.data;
                }).finally(() => {
                    this.loading.voicemail = false;
                });
            },
            removeVoicemailMessage(number) {
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to restore this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        this.voicemailmessages[number] = true;
                        axios({
                            url: this.baseAPIURL + 'classroom/' + this.classroom.id + '/voicemail/' + number,
                            method: 'DELETE',
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Content-Type': 'application/json',
                            },
                        }).then(resp => {
                        }).finally(() => {
                            this.voicemailmessages[number] = false;
                            this.loadVoicemail();
                        });
                    }
                });
            },
        }
    }
</script>
<style>
    .white-content .el-table table > tbody > tr > td {
        padding: 4px 2px;
    }

</style>
